import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import MedicalService from "../../Services/MedicalService";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import PatientService from "../../Services/PatientService";
import moment from "moment";
import { QRCodeCanvas } from "qrcode.react";

function MedicalHistory({
  chronicConditions,
  pastHistoryData,
  patientAllergyData,
  surgicalHistoryData,
  familyData,
  socialHistoryData,
  medicationData,
  immunisations,
}) {
  const [selectedHistory, setSelectedHistory] = useState("Chronic Condition");
  let patientDatalits = JSON.parse(localStorage.getItem("patientData"));
  const frontRef = useRef();
  const backRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [image, setImage] = useState(null);
  const [patientData, setPatientData] = useState();
  const [patientQrData, setPatientQrData] = useState();
  const [drugData, setDrugData] = useState([]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
    }
  };

  const [isFlipped, setIsFlipped] = useState(false);

  const handleCardClick = () => {
    setIsFlipped((prev) => !prev);
  };

  const handleDownload = async () => {
    const pdf = new jsPDF();
    const frontSide = frontRef.current;
    const backSide = backRef.current;

    if (!frontSide || !backSide) return;

    try {
      backSide.style.display = "none";

      const frontCanvas = await html2canvas(frontSide, {
        scale: 3,
        useCORS: true,
      });
      const frontImage = frontCanvas.toDataURL("image/png");

      frontSide.style.display = "none";
      backSide.style.display = "block";
      backSide.style.transform = "none";
      backSide.style.backfaceVisibility = "visible";

      const backCanvas = await html2canvas(backSide, {
        scale: 3,
        useCORS: true,
      });
      const backImage = backCanvas.toDataURL("image/png");

      frontSide.style.display = "block";
      backSide.style.display = "none";

      const imgWidth = 180;
      const frontHeight = (frontCanvas.height * imgWidth) / frontCanvas.width;
      const backHeight = (backCanvas.height * imgWidth) / backCanvas.width;

      pdf.addImage(frontImage, "PNG", 10, 10, imgWidth, frontHeight);
      pdf.addImage(
        backImage,
        "PNG",
        10,
        20 + frontHeight,
        imgWidth,
        backHeight
      );

      pdf.save("Emergency_MedicalCard.pdf");
    } finally {
      frontSide.style.display = "block";
      backSide.style.display = "block";
      backSide.style.transform = "rotateY(180deg)";
      backSide.style.backfaceVisibility = "hidden";
    }
  };

  const PaitentDetails = () => {
    const payload = {
      patientId: patientDatalits?.patientId,
      status: 1,
    };
    PatientService.HSPatientData(payload).then((result) => {
      setPatientData(result?.data[0]);
    });
  };

  useEffect(() => {
    if (selectedHistory === "EMC") {
      PatientEmergencyData();
      PaitentDetails();
    }
  }, [selectedHistory]);

  const PatientEmergencyData = () => {
    let patienObject = localStorage.getItem("patientData");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    let payload = {
      status: 1,
      patientId: patientDataV?.patientId,
    };
    MedicalService.PatientQrList(payload).then((result) => {
      if (result?.data[0]?.healthCardUrl) {
        let url =
          "https://doctor-dev.doxzon.com/emergencyqr/" +
          result?.data[0]?.healthCardUrl;
        setPatientQrData(url);
      }
    });
  };

  const calculateAge = (dobString) => {
    const dobData = dobString;
    const dobYear = dobData?.split("/")[2];
    const currYear = new Date().getFullYear();
    if (dobYear) {
      const patientAge = currYear - Number(dobYear);
      return patientAge;
    }
  };

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes()
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const generateQRCard = () => {
    let patienObject = localStorage.getItem("patient");
    let patientDataV = patienObject ? JSON.parse(patienObject) : null;
    const userObj = localStorage.getItem("login_result");
    const userData = userObj ? JSON.parse(userObj) : null;
    let payload = {
      createdBy: userData?.user?.userId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      modifiedBy: userData?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      patientId: patientDataV?.patientId,
      status: 1,
    };
    MedicalService.GenerateQr(payload).then((result) => {
      PatientEmergencyData();
    });
  };

  const renderContent = () => {
    switch (selectedHistory) {
      case "Chronic Condition":
        return (
          <div>
            {selectedHistory === "Chronic Condition" &&
              chronicConditions.map((user, i) => (
                <div key={i} className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Chronic:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {user.chronicDescription}
                      </p>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                         {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "Past Medical History":
        return (
          <div>
            {selectedHistory === "Past Medical History" &&
              pastHistoryData.map((user, i) => (
                <div key={i} className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Past Medical:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {user.pastInfo}
                      </p>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "Allergy":
        return (
          <div>
            {selectedHistory === "Allergy" &&
              patientAllergyData.map((user, i) => (
                <div key={i} className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-3">
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Drug Allergies:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.drugAllergy}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Food Allergies:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.foodAllergy}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Chemical Allergies:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.chemicalAllergy}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Other Allergies:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.otherAllergy}
                        </p>
                      </div>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "Social History":
        return (
          <div>
            {selectedHistory === "Social History" &&
              socialHistoryData.map((user, i) => (
                <div className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-3">
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Social History:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.description}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Occupation:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.occupation}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Marital Status:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.maritalStatus}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          SR with family:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.familyRelation}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          SR with friends:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.friendsRelation}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          SR with community:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.communityRelation}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          SR with people at work :
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.colleagueRelation}
                        </p>
                      </div>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                         {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "Family History":
        return (
          <div>
            {selectedHistory === "Family History" &&
              familyData.map((user, i) => (
                <div className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Reason:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {user?.description}
                      </p>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "Surgical History":
        return (
          <div>
            {selectedHistory === "Surgical History" &&
              surgicalHistoryData.map((user, i) => (
                <div key={i} className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Surgery:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {user.surgicalInfo}
                      </p>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                          {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "Medications":
        return (
          <div>
            {selectedHistory === "Medications" &&
              medicationData.map((user, i) => (
                <div className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-3">
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Drug Name:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.drugName}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Dosage:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.dosage}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Frequency:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.frequency}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Duration:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.duration}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Indication:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.indication}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Side Effect:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.sideEffects}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Composition:
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.compliance}
                        </p>
                      </div>
                      <div className="flex gap-3 items-center">
                        <p className="text-[#828282] font-sans font-normal text-xs">
                          Adverse Effects :
                        </p>
                        <p className="text-[#333333] font-sans font-medium text-xs">
                          {user.adverseEffects}
                        </p>
                      </div>
                    </div>
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Advice related to medicines :
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {user.adviceRelatedMedicine}
                      </p>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "Immunisation":
        return (
          <div>
            {selectedHistory === "Immunisation" &&
              immunisations.map((user, i) => (
                <div key={i} className="border rounded-md mt-1 p-3">
                  <div className="space-y-2">
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Immunisation:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                        {user?.description}
                      </p>
                    </div>
                    <hr />
                    <div className="flex gap-3 items-center">
                      <p className="text-[#828282] font-sans font-normal text-xs">
                        Check-up Date:
                      </p>
                      <p className="text-[#333333] font-sans font-medium text-xs">
                         {dayjs(user.givenDate).format("YYYY-MM-DD")}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        );
      case "EMC":
        return (
          <div>
            {selectedHistory === "EMC" && (
              <div className="h-[70%] overflow-y-auto scrollWidth  bg-brand-lightBg">
                <div className="p-3">
                  <div className="flex gap-3">
                    <div className="mt-2 w-[65%]">
                      <div className="">
                        {/* <h3 className="font-medium">Patient Demographics </h3> */}
                        <div>
                          <h5 className="text-xs font-medium text-gray-500">
                            Name:
                            <span className="text-xs text-[#189FAA] font-bold">
                              {`${patientData?.salutation || ""} ${
                                patientData?.firstName || ""
                              } ${patientData?.lastName || ""}`}
                            </span>
                          </h5>
                          <h5 className="text-xs font-medium text-gray-500">
                            Age:
                            <span className="text-xs text-[#189FAA] font-bold">
                              {calculateAge(patientData?.ageDob) || ""}
                            </span>
                          </h5>
                          <h5 className="text-xs font-medium text-gray-500">
                            DOB:
                            <span className="text-xs text-[#189FAA] font-bold">
                              {patientData?.dob || ""}
                            </span>
                          </h5>
                          <h5 className="text-xs font-medium text-gray-500">
                            Address:
                            <span className="text-xs text-[#189FAA] font-bold">
                              {patientData?.address1 || ""}
                            </span>
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div className="w-[35%]">
                      {patientQrData ? (
                        <>
                          <div className="w-full flex justify-center ml-2">
                            {/* <button
                              className="border rounded-lg px-3 text-xs py-1 bg-[#189FAA] font-semibold text-white hover:bg-[#189FAA]"
                              onClick={showModal}
                            >
                              View EMC
                            </button> */}
                          </div>
                          <div class="inline-block group mt-1 px-3">
                            <QRCodeCanvas value={patientQrData} size={100} />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="w-full flex justify-end">
                            <button
                              className="border rounded-lg px-3 text-xs py-1 bg-[#189FAA] font-semibold text-white hover:bg-[#338f97]"
                              onClick={() => generateQRCard()}
                            >
                              Generate QR Code
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <hr />
                  <div className="mt-2">
                    <div className="flex gap-2">
                      <p className="font-medium text-xs mt-1">Blood Group:</p>
                      <p className="font-bold text-[#338f97]">
                        {patientData?.bloodGroup}
                      </p>
                    </div>
                    <div
                      className={`${drugData.length === 1 ? "flex gap-2" : ""}`}
                    >
                      <p className="font-medium text-xs mt-1">Drug Allergy:</p>
                      <div
                        className={`border rounded-lg p-2 grid  
                  ${drugData.length === 1 ? "block" : ""} 
                  ${drugData.length > 15 ? "md:grid-cols-2" : "md:grid-cols-2"} 
                  grid-cols-2`}
                      >
                        {patientAllergyData?.map((item, idx) => (
                          <p
                            key={idx}
                            className="text-sm font-medium text-[#189FAA]"
                          >
                            {item.drugAllergy}
                          </p>
                        ))}
                      </div>
                    </div>
                    <div
                      className={`${
                        chronicConditions.length === 1 ? "flex gap-2" : ""
                      }`}
                    >
                      <p className="font-medium text-xs mt-2">
                        Chronic Conditions:
                      </p>
                      <div
                        className={`border rounded-lg p-2 grid  
                  ${chronicConditions.length === 1 ? "block" : ""} 
                  ${
                    chronicConditions.length > 15
                      ? "md:grid-cols-2"
                      : "md:grid-cols-2"
                  } 
                  grid-cols-2`}
                      >
                        {chronicConditions?.map((item, idx) => (
                          <>
                            <div key={idx} className="">
                              <p className="text-sm font-medium text-[#189FAA] truncate">
                                {item.chronicDescription}
                              </p>
                            </div>
                          </>
                        ))}
                      </div>
                    </div>
                    <div className="flex gap-2">
                      <p className="font-medium text-xs mt-1">Insurance:</p>
                      <p className="font-semibold text-[#189FAA]">
                        {patientData?.insurance}
                      </p>
                    </div>
                    <div className="">
                      <p className="font-medium text-xs mt-1">
                        Current Medications:
                      </p>
                      <div className="overflow-x-auto scrollwidth">
                        <div className="grid grid-cols-1 gap-2">
                          {medicationData?.map((row, index) => (
                            <div
                              key={index}
                              className="bg-white p-2 rounded-lg shadow-md border border-gray-300"
                            >
                              <div>
                                <div className="flex justify-between">
                                  <h3 className="text-sm font-bold text-[#189FAA]">
                                    {row.drugName}
                                  </h3>
                                  <p className="text-sm font-medium text-[#189FAA]">
                                    {row.dosage}
                                  </p>
                                  <p className="text-sm font-medium text-[#189FAA]">
                                    {row.frequency}
                                  </p>
                                </div>
                                <div className="flex justify-between mt-2">
                                  <div className="flex gap-2 items-center">
                                    <h6 className="text-xs text-[#189FAA] font-medium">
                                      On set Date
                                    </h6>
                                    <h6 className="border rounded-md text-[10px] p-1">
                                      {row.startCreatedTime?.slice(0, 11)}
                                    </h6>
                                  </div>
                                  {/* <div className="flex gap-2 items-center">
                                    <h6 className="text-xs text-[#189FAA] font-medium">
                                      To:
                                    </h6>
                                    <h6 className="border rounded-md text-[10px] p-1">
                                      {row.endCreatedTime?.slice(0, 11)}
                                    </h6>
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="border-gray-300" />
              </div>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div
      className="p-2 bg-white rounded-xl shadow-lg border h-80 overflow-y-auto"
      id="unquie-scroll"
    >
      <div className="flex sm:flex-col items-center justify-between mb-2">
        <h2 className="text-sm font-semibold text-[#D8383A] font-sans">
          Medical History
        </h2>
        <div className="flex flex-col w-fit static">
          <label
            htmlFor="history"
            className="text-[#AEAEB2] text-[10px] font-semibold relative top-2 ml-[7px] px-[3px] bg-white w-fit"
          >
            Health Records
          </label>
          <select
            id="history"
            value={selectedHistory}
            onChange={(e) => {
              setSelectedHistory(e.target.value);
            }}
            className="border-[#AEAEB2] border-2 rounded-[5px] px-[10px] py-[4px] text-xs w-[170px] focus:outline-none cursor-pointer"
          >
            <option>Chronic Condition</option>
            <option>Past Medical History</option>
            <option>Allergy</option>
            <option>Social History</option>
            <option>Family History</option>
            <option>Surgical History</option>
            <option>Medications</option>
            <option>Immunisation</option>
            <option>EMC</option>
          </select>
        </div>
      </div>
      <div className="max-h-[300px] overflow-y-auto scrollWidth pr-1">
        {renderContent()}
      </div>
    </div>
  );
}

export default MedicalHistory;
